<app-header></app-header>

<section class="container-xxl">
    <!-- BREADCRUMB AREA - STARTS -->
    <div class="breadcrumb-area">
        <nav aria-label="breadcrumb mb-0">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a class="screen-reader" [attr.title]="language=='English'?'Home':'होम'" routerLink="/">{{'Home' | translate }}</a></li>
                <li class="breadcrumb-item active screen-reader">{{ language=='English'?"Organisation Structure":"संगठन की संरचना" }}</li>

            </ol>
        </nav>
    </div>
    <!-- BREADCRUMB AREA - ENDS -->

    <div class="inner-page-sidedetails">
        <div id="section-New"></div>
        <div class="inner-banner-image">
            <div class="image-area">
                <img src="assets/images/inner-banner-2.webp" alt="inner-banner-image" class="img-fluid screen-reader">
            </div>
        </div>
        <div class="details">
            <div class="title">
                <h2 class="screen-reader">{{ language=='English'?"Organisation Structure":"संगठन की संरचना" }}</h2>
            </div>
            <div class="description">
                <div class="news mb-4">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="body genealogy-body genealogy-scroll">
                                <div class="genealogy-tree">
                                    <ul>
                                        <li>
                                            <a href="javascript:void(0);">
                                                <div class="member-view-box p-3 fs-14">
                                                    <div class="member-details screen-reader">
                                                        <span>  {{ language=='English'?"Headquaters":"मुख्यालय" }}</span>
                                                    </div>
                                                </div>
                                            </a>
                                            <!-- main parent  -->
                                            <ul class="active zoneul main-parent">
                                                <!-- main child element -->

                                                <!-- north zone -->
                                                <li class="fix-h zoneli" id="{{ 'zoneli'+zone.vch_Code+'_'+zone.id }}"
                                                    *ngFor="let zone of zoneList;">
                                                    <a href="javascript:void(0);" [attr.title]="language=='English'?'Link':'लिंक'" class="toggle"
                                                        (click)="GetRegion(zone)">
                                                        <div class="member-bg zone-box"
                                                            id="{{ 'zonebox'+zone.vch_Code+'_'+zone.id }}">
                                                            <div class="member-details">
                                                                <div class="org-tx screen-reader">
                                                                    {{ encDec.decodeHtml(language=='English'?zone.ZONE:zone.ZONE_HN) }}
                                                                    <div class="fw-tx"> {{ LocationName(zone.ZONE) }}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </a>
                                                    <!-- region element -->
                                                    <ul class="fix-w regionul {{ 'region'+zone.vch_Code+'_'+zone.id }}"
                                                        id="{{ 'regionul'+zone.vch_Code+'_'+zone.id }}">

                                                        <li class="regionli" *ngFor="let region of regionList;">
                                                            <a href="javascript:void(0);" [attr.title]="language=='English'?'Link':'लिंक'"
                                                                (click)="GetDepotList(region,zone)">
                                                                <!-- (click)="jumpToSection('jump-to-depolist')"  -->
                                                                <div class="member-view-box region-box {{ 'regionbox'+region.vch_Code+'_'+region.id }}"
                                                                    id="{{ 'regionbox'+region.vch_Code+'_'+region.id }}">
                                                                    <div class="member-details">
                                                                        <span class="screen-reader">
                                                                            {{ encDec.decodeHtml(language=='English'?region.REGION:region.REGION_HN) }}
                                                                        </span>
                                                                    </div>
                                                                </div>

                                                            </a>
                                                            <!-- depot start -->
                                                            <!-- <div class="fix-w depotul {{ 'depotul'+region.vch_Code+'_'+zone.int_Demographic_Id }}"
                                                                id="{{ 'depotul'+region.vch_Code+'_'+zone.int_Demographic_Id }}">
                                                                <h6>Depot Name</h6>
                                                                <div class="depoteli" *ngFor="let depot of depotList;">
                                                                    <a href="javascript:void(0);">
                                                                        <div class="">
                                                                            <div class="member-details">
                                                                                <span>{{ depot.DEPOT_NAME }} - ({{
                                                                                    depot.DEPOT_CODE }})</span>
                                                                                <div class="reg-tx">  </div>
                                                                            </div>
                                                                        </div>
                                                                    </a>
                                                                </div>
                                                            </div> -->
                                                            <!-- depote list end -->
                                                        </li>

                                                    </ul>
                                                    <!-- child element -->

                                                </li>
                                                <!-- north zone -->



                                                <!-- ifs zone -->
                                                <li class="fix-h" id="ifs">
                                                    <a href="javascript:void(0);" class="toggle">
                                                        <div class="member-bg">
                                                            <div class="member-details">
                                                                <div class="org-tx screen-reader">
                                                                    {{ language=='English'?"IFS":"आईएफएस" }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </li>
                                                <!-- ifs zone -->
                                                <!-- main child element -->
                                            </ul>
                                            <!-- main parent  -->
                                        </li>
                                    </ul>

                                </div>
                                <div id="jump-to-depolist"></div>
                                <div class="depot-area-details" id="depotdiv" style="display: none;">
                                    <div class="container">
                                        <div class="p-2 custom-2Xborder-bottom">
                                            <h5 class="mb-0 screen-reader">
                                                {{  encDec.decodeHtml(language=='English'?'District wise Depot details of '+currentRegion.REGION:currentRegion.REGION_HN+' के जिलेवार डिपो विवरण') }} 
                                            </h5>
                                        </div>
                                        <div class="p-2">
                                            <ul>
                                                <ng-container *ngFor="let list of districtAnddepotList;">
                                                    <h5 class="district-name screen-reader">
                                                        <i class="bi bi-circle-fill fs-0-6"></i>
                                                        
                                                        {{ encDec.decodeHtml(
                                                            language=='English'?
                                                            list.DISTRICT:
                                                            list.DISTRICT_HN=='' || list.DISTRICT_HN==null?list.DISTRICT:list.DISTRICT_HN) 
                                                        }} 
                                                        <span class="badge badge-sm bg-light-green">{{ list.depotList.length }}</span>
                                                    </h5>
                                                    <li *ngFor="let item of list.depotList;" class="screen-reader">
                                                        {{ encDec.decodeHtml(
                                                            language=='English'?
                                                            item.DEPOT_NAME:
                                                            item.DEPOT_NAME_HN=='' || item.DEPOT_NAME_HN==null?item.DEPOT_NAME:item.DEPOT_NAME_HN
                                                            ) 
                                                        }} -
                                                        ({{item.DEPOT_CODE }})
                                                    </li>
                                                </ng-container>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</section>

<app-clients></app-clients>

<app-footer></app-footer>